module.exports = __webpack_public_path__ + "static/media/whiteFull.3ffa0b4e.svg";